<script lang="ts" module>
  import type { Snippet } from 'svelte';
  export interface CollapsibleContentProps {
    children?: Snippet;
  }
</script>

<script lang="ts">
  import { useCollapsibleContext } from '../use-collapsible-context';

  const { children, ...props }: CollapsibleContentProps = $props();
  const collapsible = useCollapsibleContext();
  const contentProps = $derived({ ...collapsible.api.getContentProps(), ...props});
</script>

<div {...contentProps}>
  {#if children}
    {@render children()}
  {/if}
</div>
